import getMuiTheme from 'material-ui/styles/getMuiTheme';

/*
  se si modifica la width del drawer (menu laterale) allora bisogna anche modificare
  il paddingLeftDrawerOpen dell'app inline style
*/
const themeDefault = getMuiTheme({
  fontFamily : "'NeoSans', 'Calibri Light', 'Roboto'",
  palette: {
  },
  appBar: {
    height: 57,
    color: '#02ABCA'
  },
  drawer: {
    width: 250,
    color: 'white'
  },
  raisedButton: {
    primaryColor: '#02ABCA'
  },

});


export default themeDefault;


// WEBPACK FOOTER //
// ./src/layouts/material-admin/theme-default.js